var _rect, _rect2, _rect3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "#591BC2",
  rx: 24
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "url(#search_svg__a)",
  rx: 24
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 46,
  x: 1,
  y: 1,
  stroke: "url(#search_svg__b)",
  strokeOpacity: 0.2,
  strokeWidth: 2,
  rx: 23
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M29.205 27.952 33 31.746 31.746 33l-3.794-3.795a7.94 7.94 0 0 1-4.977 1.745A7.98 7.98 0 0 1 15 22.975 7.98 7.98 0 0 1 22.975 15a7.98 7.98 0 0 1 7.975 7.975 7.94 7.94 0 0 1-1.745 4.977m-1.778-.658a6.19 6.19 0 0 0 1.75-4.32 6.2 6.2 0 0 0-6.202-6.202 6.2 6.2 0 0 0-6.203 6.203 6.2 6.2 0 0 0 6.203 6.202 6.19 6.19 0 0 0 4.32-1.75z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "search_svg__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 -36 40.592 0 24 60)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.481,
  stopColor: "#D34EFF",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4E80FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "search_svg__b",
  x1: 24,
  x2: 24,
  y1: 0,
  y2: 48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
export default SvgSearch;